import type { DesignProductPresenter } from '../../../../products/';
import type { LocalisedCategory } from '../useCategoriesConfig';
import type { Category } from './categories';

export const localisedBaseCategories = (
    categories: Record<string, Category>,
    productPresenters: Record<string, DesignProductPresenter>
): LocalisedCategory => ({
    'da-DK': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.glossyBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.matteBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.gbbPremiumBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.fliplidboxes,
                productPresenters.wrappingPaper,
                productPresenters.pulloutBoxes,
                productPresenters.hangTags,
                productPresenters.papercup,
                productPresenters.mailerBoxes,
                productPresenters.promotionalBoxesEu,
                productPresenters.paperBag,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.postcards,
                productPresenters.foldedLeaflets,
                productPresenters.menus,
                productPresenters.bookmarks,
                productPresenters.photoboothMagnets,
                productPresenters.doorHanger,
                productPresenters.ringBinders,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.posters,
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.carDoorMagnets,
                productPresenters.windowDecals,
                productPresenters.metalSigns,
                productPresenters.foamBoards,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.giftCertificates,
                productPresenters.selfInkingStamps,
                productPresenters.circleStamps,
                productPresenters.letterhead,
                productPresenters.notepads,
                productPresenters.textileStamps,
                productPresenters.notebooks,
                productPresenters.loyaltyCardStamp,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.envelopeSeals,
                productPresenters.stickerSingles,
                productPresenters.returnAddressLabels,
                productPresenters.productLabels,
                productPresenters.rollLabels,
                productPresenters.circleStickers,
                productPresenters.euRectangleStickers,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.standardEmbroideredHats,
                productPresenters.cottoVerMensTShirt,
                productPresenters.classicCottonToteBagSmall,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.multiDecoVistaprintEmbroideredHats,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingMenuCards,
                productPresenters.enclosureCards,
                productPresenters.weddingFoamBoards,
                productPresenters.saveTheDateCards,
                productPresenters.weddingPrograms,
                productPresenters.saveTheDateMagnet,
                productPresenters.rsvpCards,
            ],
        },
    ],
    'de-AT': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.metallicBusinessCards,
                productPresenters.softTouchBusinessCards,
                productPresenters.loyaltyCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.wrappingPaper,
                productPresenters.hangTags,
                productPresenters.fliplidboxes,
                productPresenters.promotionalBoxesEu,
                productPresenters.paperBag,
                productPresenters.pulloutBoxes,
                productPresenters.mailerBoxes,
                productPresenters.paperBag,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.foldedLeaflets,
                productPresenters.postcards,
                productPresenters.menus,
                productPresenters.customTickets,
                productPresenters.presentationFolders,
                productPresenters.bookmarks,
                productPresenters.coasters,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.euVinylBanners,
                productPresenters.retractableBanners,
                productPresenters.posters,
                productPresenters.metalSigns,
                productPresenters.windowDecals,
                productPresenters.carDoorMagnets,
                productPresenters.acrylicSigns,
                productPresenters.carWindowDecals,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.giftCertificates,
                productPresenters.selfInkingStamps,
                productPresenters.letterhead,
                productPresenters.notepads,
                productPresenters.loyaltyCardStamp,
                productPresenters.circleStamps,
                productPresenters.notebooks,
                productPresenters.businessEnvelopes,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.rollLabels,
                productPresenters.returnAddressLabels,
                productPresenters.productLabels,
                productPresenters.foodLabels,
                productPresenters.stickerSingles,
                productPresenters.qRcodestickers,
                productPresenters.euRectangleStickers,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.embroideredPolos,
                productPresenters.cottoVerMensTShirt,
                productPresenters.fullCustomCyclingJersey,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.fullCustomToteBag,
                productPresenters.bcId003HoodedSweat,
                productPresenters.vistaprintCuffedBeanie,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingMenuCards,
                productPresenters.saveTheDateCards,
                productPresenters.weddingFoamBoards,
                productPresenters.rsvpCards,
                productPresenters.weddingPrograms,
                productPresenters.enclosureCards,
                productPresenters.saveTheDateMagnet,
            ],
        },
    ],
    'de-CH': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.glossyBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.matteBusinessCards,
                productPresenters.metallicBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.wrappingPaper,
                productPresenters.hangTags,
                productPresenters.fliplidboxes,
                productPresenters.paperBag,
                productPresenters.flexiblePackagingDoypacks,
                productPresenters.mailerBoxes,
                productPresenters.raisedFoilSwingTags,
                productPresenters.pulloutBoxes,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.postcards,
                productPresenters.foldedLeaflets,
                productPresenters.menus,
                productPresenters.customTickets,
                productPresenters.bookmarks,
                productPresenters.placemats,
                productPresenters.presentationFolders,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.retractableBanners,
                productPresenters.carDoorMagnets,
                productPresenters.euVinylBanners,
                productPresenters.posters,
                productPresenters.windowDecals,
                productPresenters.carWindowDecals,
                productPresenters.metalSigns,
                productPresenters.flags,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.giftCertificates,
                productPresenters.selfInkingStamps,
                productPresenters.letterhead,
                productPresenters.loyaltyCardStamp,
                productPresenters.notepads,
                productPresenters.notebooks,
                productPresenters.businessEnvelopes,
                productPresenters.invoicePads,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.returnAddressLabels,
                productPresenters.rollLabels,
                productPresenters.productLabels,
                productPresenters.circleStickers,
                productPresenters.foodLabels,
                productPresenters.qRcodestickers,
                productPresenters.nameTags,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.cottoVerMensTShirt,
                productPresenters.embroideredPolos,
                productPresenters.standardEmbroideredHats,
                productPresenters.fullCustomCyclingJersey,
                productPresenters.gildanZipUpSweatshirt,
                productPresenters.vistaPrintPrintedBaseballCap,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.saveTheDateCards,
                productPresenters.weddingFoamBoards,
                productPresenters.weddingMenuCards,
                productPresenters.enclosureCards,
                productPresenters.weddingPrograms,
            ],
        },
    ],
    'de-DE': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.glossyBusinessCards,
                productPresenters.metallicBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.wrappingPaper,
                productPresenters.hangTags,
                productPresenters.fliplidboxes,
                productPresenters.paperBag,
                productPresenters.pulloutBoxes,
                productPresenters.papercup,
                productPresenters.raisedFoilSwingTags,
                productPresenters.promotionalBoxesEu,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.postcards,
                productPresenters.foldedLeaflets,
                productPresenters.menus,
                productPresenters.presentationFolders,
                productPresenters.customTickets,
                productPresenters.bookmarks,
                productPresenters.doorHanger,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.retractableBanners,
                productPresenters.posters,
                productPresenters.euVinylBanners,
                productPresenters.carDoorMagnets,
                productPresenters.windowDecals,
                productPresenters.euMeshBanners,
                productPresenters.metalSigns,
                productPresenters.acrylicSigns,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.selfInkingStamps,
                productPresenters.giftCertificates,
                productPresenters.letterhead,
                productPresenters.notepads,
                productPresenters.circleStamps,
                productPresenters.loyaltyCardStamp,
                productPresenters.notebooks,
                productPresenters.businessEnvelopes,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.returnAddressLabels,
                productPresenters.customStickers,
                productPresenters.rollLabels,
                productPresenters.productLabels,
                productPresenters.euRectangleStickers,
                productPresenters.stickerSingles,
                productPresenters.qRcodestickers,
                productPresenters.circleStickers,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.embroideredPolos,
                productPresenters.standardEmbroideredHats,
                productPresenters.cottoVerMensTShirt,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.gildanZipUpSweatshirt,
                productPresenters.vistaprintCuffedBeanie,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.saveTheDateCards,
                productPresenters.weddingMenuCards,
                productPresenters.weddingFoamBoards,
                productPresenters.saveTheDateMagnet,
                productPresenters.weddingPrograms,
                productPresenters.enclosureCards,
                productPresenters.rsvpCards,
            ],
        },
    ],
    'en-AU': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.customStickers,
                productPresenters.mensTee,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.glossyBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.magneticBusinessCards,
                productPresenters.foilBusinessCards,
                productPresenters.entryLevelBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.mailingBoxes,
                productPresenters.swingTags,
                productPresenters.customPrintedTissuePaper,
                productPresenters.promotionalBoxes,
                productPresenters.paperCups,
                productPresenters.paperBag,
                productPresenters.shippingEnvelopes,
                productPresenters.standUpPouches,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.postcards,
                productPresenters.foldedLeaflets,
                productPresenters.menus,
                productPresenters.presentationFolders,
                productPresenters.magneticPostcards,
                productPresenters.bookmarks,
                productPresenters.doorHanger,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.retractableBanners,
                productPresenters.vinylBanners,
                productPresenters.carDoorMagnets,
                productPresenters.lawnSigns,
                productPresenters.flags,
                productPresenters.posters,
                productPresenters.windowDecals,
                productPresenters.aFrameSandwichBoards,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.letterhead,
                productPresenters.selfInkingStamps,
                productPresenters.giftCertificates,
                productPresenters.notepads,
                productPresenters.notebooks,
                productPresenters.loyaltyCardStamps,
                productPresenters.hardcoverNotebooks,
                productPresenters.fabricStamps,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.vinylBanners,
                productPresenters.meshBanners,
                productPresenters.outdoorRetractableBanner,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.productLabels,
                productPresenters.waterproofSheetStickers,
                productPresenters.syntheticRollLabels,
                productPresenters.rollLabels,
                productPresenters.returnAddressLabels,
                productPresenters.transparentLabels,
                productPresenters.holographicStickers,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.mensTee,
                productPresenters.womensTee,
                productPresenters.gildanMensPoloShirt,
                productPresenters.gildanWomensPoloShirt,
                productPresenters.printedCap,
                productPresenters.basicKidsTShirts,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingPrograms,
                productPresenters.enclosureCards,
                productPresenters.weddingMenus,
                productPresenters.receptionCards,
                productPresenters.stubbyHolder,
                productPresenters.wineLabels,
                productPresenters.paperCoasters,
            ],
        },
    ],
    'en-CA': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.stickerSingles,
                productPresenters.flyers,
                productPresenters.bellaCanvasUnisexShortSleeveJerseyTShirtDtg2go,
                productPresenters.classicCottonToteBagSmall,
                productPresenters.letterhead,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.premiumPlusBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.embossedGlossBusinessCards,
                productPresenters.glossyBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.foilAccentBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.standUpPouches,
                productPresenters.hangTags,
                productPresenters.displayMailers,
                productPresenters.productBoxes,
                productPresenters.naWrappingPaper,
                productPresenters.polyMailers,
                productPresenters.customTissuePaper,
                productPresenters.shippingBoxes,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyers,
                productPresenters.postcards,
                productPresenters.doorHangers,
                productPresenters.presentationFolders,
                productPresenters.rackCards,
                productPresenters.magneticCalendars,
                productPresenters.carbonlessForms,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.retractableBanners,
                productPresenters.vinylBanners,
                productPresenters.yardSigns,
                productPresenters.posters,
                productPresenters.foamBoards,
                productPresenters.carDoorMagnets,
                productPresenters.flags,
                productPresenters.windowDecals,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.notepads,
                productPresenters.letterhead,
                productPresenters.giftCertificate,
                productPresenters.selfInkingStamps,
                productPresenters.notebooks,
                productPresenters.circleSelfInkingStamps,
                productPresenters.stickyNotebookNa,
                productPresenters.loyaltyCardStamps,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.vinylBanners,
                productPresenters.stepAndRepeatBanners,
                productPresenters.meshBanners,
                productPresenters.fabricBanners,
                productPresenters.pennantBanners,
                productPresenters.xBanners,
                productPresenters.poleBanners,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.rollLabels,
                productPresenters.customSheetStickers,
                productPresenters.stickerSingles,
                productPresenters.circleStickers,
                productPresenters.foodPackagingLabels,
                productPresenters.rectangleStickers,
                productPresenters.plasticLabels,
                productPresenters.returnAddressLabels,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.bellaCanvasUnisexShortSleeveJerseyTShirtDtg2go,
                productPresenters.gildanHeavyCottonYouthTShirtNa,
                productPresenters.gildanZipUpSweatshirt,
                productPresenters.standardEmbroideredHats,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.portAuthorityLifestyleBrimHatNa,
                productPresenters.classicCottonToteBagSmall,
                productPresenters.deluxeCottonTote,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.foamBoardWeddingSigns,
                productPresenters.weddingPrograms,
                productPresenters.weddingMenus,
                productPresenters.weddingThankYouCards,
                productPresenters.naWeddingCelebrationInvitations,
                productPresenters.acrylicWeddingSigns,
                productPresenters.weddingEnclosureCards,
            ],
        },
    ],
    'en-GB': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.fastShippingBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.glossyBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.matteBusinessCards,
                productPresenters.qrCodeBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.fliplidboxes,
                productPresenters.hangTags,
                productPresenters.promotionalBoxesEu,
                productPresenters.pulloutBoxes,
                productPresenters.mailerBoxes,
                productPresenters.wrappingPaper,
                productPresenters.flexiblePackagingDoypacks,
                productPresenters.raisedFoilSwingTags,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.postcards,
                productPresenters.foldedLeaflets,
                productPresenters.menus,
                productPresenters.bookmarks,
                productPresenters.customTickets,
                productPresenters.presentationFolders,
                productPresenters.doorHanger,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.euVinylBanners,
                productPresenters.posters,
                productPresenters.retractableBanners,
                productPresenters.carDoorMagnets,
                productPresenters.foamBoards,
                productPresenters.lawnSigns,
                productPresenters.windowDecals,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.giftCertificates,
                productPresenters.selfInkingStamps,
                productPresenters.letterhead,
                productPresenters.notepads,
                productPresenters.loyaltyCardStamp,
                productPresenters.notebooks,
                productPresenters.circleStamps,
                productPresenters.invoicePads,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.productLabels,
                productPresenters.returnAddressLabels,
                productPresenters.rollLabels,
                productPresenters.circleStickers,
                productPresenters.euRectangleStickers,
                productPresenters.stickerSingles,
                productPresenters.envelopeSeals,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.cottoVerMensTShirt,
                productPresenters.embroideredPolos,
                productPresenters.classicCottonToteBagSmall,
                productPresenters.cottoVerWomensTShirt,
                productPresenters.gildanZipUpSweatshirt,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingFoamBoards,
                productPresenters.saveTheDateCards,
                productPresenters.weddingPrograms,
                productPresenters.weddingMenuCards,
                productPresenters.saveTheDateMagnet,
                productPresenters.rsvpCards,
                productPresenters.enclosureCards,
            ],
        },
    ],
    'en-IE': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.glossyBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.metallicBusinessCards,
                productPresenters.gbbPremiumBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.wrappingPaper,
                productPresenters.fliplidboxes,
                productPresenters.promotionalBoxesEu,
                productPresenters.hangTags,
                productPresenters.mailerBoxes,
                productPresenters.recycledpolymailers,
                productPresenters.pulloutBoxes,
                productPresenters.papercup,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.foldedLeaflets,
                productPresenters.postcards,
                productPresenters.bookmarks,
                productPresenters.menus,
                productPresenters.customTickets,
                productPresenters.coasters,
                productPresenters.presentationFolders,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.retractableBanners,
                productPresenters.posters,
                productPresenters.foamBoards,
                productPresenters.euVinylBanners,
                productPresenters.carDoorMagnets,
                productPresenters.windowDecals,
                productPresenters.metalSigns,
                productPresenters.carDoorDecals,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.giftCertificates,
                productPresenters.selfInkingStamps,
                productPresenters.letterhead,
                productPresenters.circleStamps,
                productPresenters.notepads,
                productPresenters.pocketStamps,
                productPresenters.loyaltyCardStamp,
                productPresenters.notebooks,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.returnAddressLabels,
                productPresenters.rollLabels,
                productPresenters.productLabels,
                productPresenters.envelopeSeals,
                productPresenters.circleStickers,
                productPresenters.stickerSingles,
                productPresenters.nameTags,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.embroideredPolos,
                productPresenters.cottoVerMensTShirt,
                productPresenters.basicKidsTShirtShortSleeve,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.deluxeCottonTote,
                productPresenters.footballShirt,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingFoamBoards,
                productPresenters.saveTheDateCards,
                productPresenters.weddingPrograms,
                productPresenters.weddingMenuCards,
                productPresenters.enclosureCards,
                productPresenters.rsvpCards,
                productPresenters.saveTheDateMagnet,
            ],
        },
    ],
    'en-IN': [],
    'en-NZ': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.customStickers,
                productPresenters.mensTee,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.glossyBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.qrCodeBusinessCards,
                productPresenters.squareBusinessCards,
                productPresenters.plasticBusinessCards,
                productPresenters.spotUVBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.swingTags,
                productPresenters.mailingBoxes,
                productPresenters.shippingEnvelopes,
                productPresenters.paperBag,
                productPresenters.shippingBoxes,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.postcards,
                productPresenters.foldedLeaflets,
                productPresenters.presentationFolders,
                productPresenters.menus,
                productPresenters.bookmarks,
                productPresenters.tableTents,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.retractableBanners,
                productPresenters.vinylBanners,
                productPresenters.carDoorMagnets,
                productPresenters.posters,
                productPresenters.windowDecals,
                productPresenters.foamBoards,
                productPresenters.flagsNZ,
                productPresenters.tablecloths,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.letterhead,
                productPresenters.selfInkingStamps,
                productPresenters.giftCertificates,
                productPresenters.notepads,
                productPresenters.notebooks,
                productPresenters.circleStamps,
                productPresenters.pocketStamps,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.vinylBanners,
                productPresenters.meshBanners,
                productPresenters.outdoorRetractableBanner,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.rollLabels,
                productPresenters.productLabels,
                productPresenters.returnAddressLabels,
                productPresenters.customStickers,
                productPresenters.wineLabels,
                productPresenters.nameTags,
                productPresenters.waterproofSheetStickers,
                productPresenters.envelopeSeals,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.gildanMensPoloShirt,
                productPresenters.classicCottonToteBagSmall,
                productPresenters.hoodie,
                productPresenters.gildanWomensPoloShirt,
                productPresenters.r231fResultLadiesPrintableSoftshellJacket,
                productPresenters.vistaprintCuffedBeanie,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.saveTheDateCards,
                productPresenters.weddingPrograms,
                productPresenters.weddingMenus,
                productPresenters.saveTheDateMagnet,
                productPresenters.rsvpCards,
                productPresenters.enclosureCards,
            ],
        },
    ],
    'en-SG': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.gildanMensTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.qrCodeBusinessCards,
                productPresenters.glossyBusinessCards,
                productPresenters.entryLevelBusinessCards,
                productPresenters.magneticBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.foldedSwingTags,
                productPresenters.swingTags,
                productPresenters.shippingEnvelopes,
                productPresenters.shippingBoxes,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.postcards,
                productPresenters.foldedLeaflets,
                productPresenters.presentationFolders,
                productPresenters.bookmarks,
                productPresenters.tableTents,
                productPresenters.menus,
                productPresenters.doorHanger,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.retractableBanners,
                productPresenters.vinylBanners,
                productPresenters.metalSigns,
                productPresenters.cardboardSigns,
                productPresenters.windowDecals,
                productPresenters.posters,
                productPresenters.acrylicSigns,
                productPresenters.foamBoards,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.selfInkingStamps,
                productPresenters.letterhead,
                productPresenters.notepads,
                productPresenters.notebooks,
                productPresenters.giftCertificates,
                productPresenters.pocketStamps,
                productPresenters.signatureStamps,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.vinylBanners,
                productPresenters.meshBanners,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.returnAddressLabels,
                productPresenters.productLabels,
                productPresenters.waterproofSheetStickers,
                productPresenters.envelopeSeals,
                productPresenters.nameTags,
                productPresenters.rollLabels,
                productPresenters.mailingLabels,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.gildanMensTShirt,
                productPresenters.vistaprint6PanelBaseballHat,
                productPresenters.asColourWomensStapleTShirt,
                productPresenters.gildanWomensPoloShirt,
                productPresenters.gildanWomensTShirt,
                productPresenters.gildanMensPoloShirt,
                productPresenters.vistaprintTwoToneZipCottonToteBag,
                productPresenters.premiumAsColorMensTShirts,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingPrograms,
                productPresenters.weddingMenus,
                productPresenters.saveTheDateCards,
            ],
        },
    ],
    'en-US': [
        categories.logoAndBrand,
        categories.businessCards,
        categories.packaging,
        categories.marketingMaterials,
        categories.signsAndPosters,
        categories.stationery,
        categories.banners,
        categories.labelsAndStickers,
        categories.clothingAndBags,
        categories.wedding,
    ],
    'es-ES': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.glossyBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.qrCodeBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.wrappingPaper,
                productPresenters.hangTags,
                productPresenters.fliplidboxes,
                productPresenters.papercup,
                productPresenters.pulloutBoxes,
                productPresenters.mailerBoxes,
                productPresenters.promotionalBoxesEu,
                productPresenters.pillowBoxesEu,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.foldedLeaflets,
                productPresenters.postcards,
                productPresenters.bookmarks,
                productPresenters.menus,
                productPresenters.presentationFolders,
                productPresenters.singlePocketFolders,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.euVinylBanners,
                productPresenters.retractableBanners,
                productPresenters.windowDecals,
                productPresenters.posters,
                productPresenters.carDoorMagnets,
                productPresenters.outdoorPoster,
                productPresenters.acrylicSigns,
                productPresenters.flags,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.selfInkingStamps,
                productPresenters.giftCertificates,
                productPresenters.circleStamps,
                productPresenters.letterhead,
                productPresenters.notebooks,
                productPresenters.loyaltyCardStamp,
                productPresenters.notepads,
                productPresenters.journals,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.returnAddressLabels,
                productPresenters.rollLabels,
                productPresenters.productLabels,
                productPresenters.circleStickers,
                productPresenters.euRectangleStickers,
                productPresenters.qRcodestickers,
                productPresenters.stickerSingles,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.standardEmbroideredHats,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.cottoVerMensTShirt,
                productPresenters.embroideredPolos,
                productPresenters.footballShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingFoamBoards,
                productPresenters.weddingMenuCards,
                productPresenters.saveTheDateCards,
                productPresenters.saveTheDateMagnet,
                productPresenters.weddingPrograms,
                productPresenters.enclosureCards,
                productPresenters.rsvpCards,
            ],
        },
    ],
    'es-US': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyers,
                productPresenters.letterhead,
                productPresenters.bellaCanvasUnisexShortSleeveJerseyTShirtDtg2go,
                productPresenters.classicCottonToteBagSmall,
                productPresenters.stickerSingles,
            ],
        },
        categories.businessCards,
        categories.packaging,
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyers,
                productPresenters.postcards,
                productPresenters.doorHangers,
                productPresenters.rackCards,
                productPresenters.presentationFolders,
                productPresenters.mailingServicesPostcard,
                productPresenters.flatMenus,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.vinylBanners,
                productPresenters.retractableBanners,
                productPresenters.yardSigns,
                productPresenters.carDoorMagnets,
                productPresenters.posters,
                productPresenters.foamBoards,
                productPresenters.flags,
                productPresenters.tablecloths,
            ],
        },
        categories.stationery,
        categories.banners,
        categories.labelsAndStickers,
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.bellaCanvasUnisexShortSleeveJerseyTShirtDtg2go,
                productPresenters.standardEmbroideredHats,
                productPresenters.classicCottonToteBagSmall,
                productPresenters.carharttMidweightHoodedSweatshirtNa,
                productPresenters.hanesAuthenticYouthShortSleeveTShirtNa,
                productPresenters.vistaprintCuffedBeanie,
                productPresenters.jerzeesPolo,
                productPresenters.vistaprintPremiumLaptopBackpack15,
            ],
        },
        categories.wedding,
    ],
    'fi-FI': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.glossyBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.qrCodeBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.hangTags,
                productPresenters.promotionalBoxesEu,
                productPresenters.paperBag,
                productPresenters.papercup,
                productPresenters.iceCreamCup,
                productPresenters.shippingBoxes,
                productPresenters.mailerBoxes,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.postcards,
                productPresenters.foldedLeaflets,
                productPresenters.menus,
                productPresenters.pinBadges,
                productPresenters.customTickets,
                productPresenters.bookmarks,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.retractableBanners,
                productPresenters.posters,
                productPresenters.windowDecals,
                productPresenters.carDoorMagnets,
                productPresenters.lawnSigns,
                productPresenters.euVinylBanners,
                productPresenters.windowClings,
                productPresenters.lawnSigns,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.giftCertificates,
                productPresenters.selfInkingStamps,
                productPresenters.circleStamps,
                productPresenters.notebooks,
                productPresenters.letterhead,
                productPresenters.loyaltyCardStamp,
                productPresenters.greenLineStamps,
                productPresenters.notepads,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.returnAddressLabels,
                productPresenters.productLabels,
                productPresenters.stickerSingles,
                productPresenters.rollLabels,
                productPresenters.envelopeSeals,
                productPresenters.nameTags,
                productPresenters.circleStickers,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.embroideredPolos,
                productPresenters.cottoVerMensTShirt,
                productPresenters.basicKidsTShirtShortSleeve,
                productPresenters.gildanZipUpSweatshirt,
                productPresenters.basicMensLongSleeveTShirt,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingPrograms,
                productPresenters.weddingFoamBoards,
                productPresenters.weddingMenuCards,
                productPresenters.saveTheDateCards,
                productPresenters.enclosureCards,
                productPresenters.saveTheDateMagnet,
                productPresenters.rsvpCards,
            ],
        },
    ],
    'fr-BE': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.matteBusinessCards,
                productPresenters.qrCodeBusinessCards,
                productPresenters.glossyBusinessCards,
                productPresenters.softTouchBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.fliplidboxes,
                productPresenters.hangTags,
                productPresenters.promotionalBoxesEu,
                productPresenters.papercup,
                productPresenters.pulloutBoxes,
                productPresenters.paperBag,
                productPresenters.flexiblePackagingDoypacks,
                productPresenters.lockBottomBoxes,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.postcards,
                productPresenters.foldedLeaflets,
                productPresenters.menus,
                productPresenters.photoboothMagnets,
                productPresenters.placemats,
                productPresenters.bookmarks,
                productPresenters.presentationFolders,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.euVinylBanners,
                productPresenters.posters,
                productPresenters.carDoorMagnets,
                productPresenters.retractableBanners,
                productPresenters.flags,
                productPresenters.euMeshBanners,
                productPresenters.windowDecals,
                productPresenters.metalSigns,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.selfInkingStamps,
                productPresenters.giftCertificates,
                productPresenters.circleStamps,
                productPresenters.loyaltyCardStamp,
                productPresenters.letterhead,
                productPresenters.notepads,
                productPresenters.businessEnvelopes,
                productPresenters.greenLineStamps,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.rollLabels,
                productPresenters.returnAddressLabels,
                productPresenters.productLabels,
                productPresenters.stickerSingles,
                productPresenters.envelopeSeals,
                productPresenters.circleStickers,
                productPresenters.euRectangleStickers,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.cottoVerMensTShirt,
                productPresenters.embroideredPolos,
                productPresenters.standardEmbroideredHats,
                productPresenters.kidsBasicTShirts,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.basicKidsTShirtShortSleeve,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingFoamBoards,
                productPresenters.saveTheDateCards,
                productPresenters.weddingMenuCards,
                productPresenters.enclosureCards,
                productPresenters.weddingPrograms,
                productPresenters.saveTheDateMagnet,
                productPresenters.rsvpCards,
            ],
        },
    ],
    'fr-CA': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.stickerSingles,
                productPresenters.flyers,
                productPresenters.bellaCanvasUnisexShortSleeveJerseyTShirtDtg2go,
                productPresenters.classicCottonToteBagSmall,
                productPresenters.letterhead,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.premiumPlusBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.embossedGlossBusinessCards,
                productPresenters.glossyBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.foilAccentBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.standUpPouches,
                productPresenters.hangTags,
                productPresenters.displayMailers,
                productPresenters.productBoxes,
                productPresenters.naWrappingPaper,
                productPresenters.polyMailers,
                productPresenters.customTissuePaper,
                productPresenters.shippingBoxes,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyers,
                productPresenters.postcards,
                productPresenters.doorHangers,
                productPresenters.presentationFolders,
                productPresenters.rackCards,
                productPresenters.magneticCalendars,
                productPresenters.carbonlessForms,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.retractableBanners,
                productPresenters.vinylBanners,
                productPresenters.yardSigns,
                productPresenters.posters,
                productPresenters.foamBoards,
                productPresenters.carDoorMagnets,
                productPresenters.flags,
                productPresenters.windowDecals,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.notepads,
                productPresenters.letterhead,
                productPresenters.giftCertificate,
                productPresenters.selfInkingStamps,
                productPresenters.notebooks,
                productPresenters.circleSelfInkingStamps,
                productPresenters.stickyNotebookNa,
                productPresenters.loyaltyCardStamps,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.vinylBanners,
                productPresenters.stepAndRepeatBanners,
                productPresenters.meshBanners,
                productPresenters.fabricBanners,
                productPresenters.pennantBanners,
                productPresenters.xBanners,
                productPresenters.poleBanners,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.rollLabels,
                productPresenters.customSheetStickers,
                productPresenters.stickerSingles,
                productPresenters.circleStickers,
                productPresenters.foodPackagingLabels,
                productPresenters.rectangleStickers,
                productPresenters.plasticLabels,
                productPresenters.returnAddressLabels,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.bellaCanvasUnisexShortSleeveJerseyTShirtDtg2go,
                productPresenters.gildanHeavyCottonYouthTShirtNa,
                productPresenters.gildanZipUpSweatshirt,
                productPresenters.standardEmbroideredHats,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.portAuthorityLifestyleBrimHatNa,
                productPresenters.classicCottonToteBagSmall,
                productPresenters.deluxeCottonTote,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.foamBoardWeddingSigns,
                productPresenters.weddingPrograms,
                productPresenters.weddingMenus,
                productPresenters.weddingThankYouCards,
                productPresenters.naWeddingCelebrationInvitations,
                productPresenters.acrylicWeddingSigns,
                productPresenters.weddingEnclosureCards,
            ],
        },
    ],
    'fr-CH': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.matteBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.qrCodeBusinessCards,
                productPresenters.glossyBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.hangTags,
                productPresenters.fliplidboxes,
                productPresenters.pulloutBoxes,
                productPresenters.mailerBoxes,
                productPresenters.paperBag,
                productPresenters.pillowBoxesEu,
                productPresenters.lockBottomBoxes,
                productPresenters.promotionalBoxesEu,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.foldedLeaflets,
                productPresenters.postcards,
                productPresenters.menus,
                productPresenters.placemats,
                productPresenters.bookmarks,
                productPresenters.presentationFolders,
                productPresenters.photoboothMagnets,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.euVinylBanners,
                productPresenters.retractableBanners,
                productPresenters.carDoorMagnets,
                productPresenters.posters,
                productPresenters.flags,
                productPresenters.windowDecals,
                productPresenters.euMeshBanners,
                productPresenters.metalSigns,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.selfInkingStamps,
                productPresenters.giftCertificates,
                productPresenters.loyaltyCardStamp,
                productPresenters.notepads,
                productPresenters.letterhead,
                productPresenters.notebooks,
                productPresenters.circleStamps,
                productPresenters.textileStamps,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.productLabels,
                productPresenters.rollLabels,
                productPresenters.returnAddressLabels,
                productPresenters.customStickers,
                productPresenters.stickerSingles,
                productPresenters.wineLabels,
                productPresenters.envelopeSeals,
                productPresenters.qRcodestickers,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.cottoVerMensTShirt,
                productPresenters.standardEmbroideredHats,
                productPresenters.footballShirt,
                productPresenters.basicKidsTShirtShortSleeve,
                productPresenters.kidsFootballShirts,
                productPresenters.fullCustomCyclingJersey,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingMenuCards,
                productPresenters.weddingFoamBoards,
                productPresenters.saveTheDateCards,
                productPresenters.weddingPrograms,
                productPresenters.enclosureCards,
                productPresenters.saveTheDateMagnet,
            ],
        },
    ],
    'fr-FR': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.glossyBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.softTouchBusinessCards,
                productPresenters.matteBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.fliplidboxes,
                productPresenters.hangTags,
                productPresenters.pulloutBoxes,
                productPresenters.paperBag,
                productPresenters.mailerBoxes,
                productPresenters.promotionalBoxesEu,
                productPresenters.wrappingPaper,
                productPresenters.flexiblePackagingDoypacks,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.foldedLeaflets,
                productPresenters.postcards,
                productPresenters.menus,
                productPresenters.bookmarks,
                productPresenters.presentationFolders,
                productPresenters.customTickets,
                productPresenters.placemats,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.euVinylBanners,
                productPresenters.carDoorMagnets,
                productPresenters.retractableBanners,
                productPresenters.posters,
                productPresenters.lawnSigns,
                productPresenters.windowDecals,
                productPresenters.carDoorDecals,
                productPresenters.metalSigns,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.rollLabels,
                productPresenters.returnAddressLabels,
                productPresenters.productLabels,
                productPresenters.circleStickers,
                productPresenters.stickerSingles,
                productPresenters.foodLabels,
                productPresenters.euRectangleStickers,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.cottoVerMensTShirt,
                productPresenters.embroideredPolos,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.standardEmbroideredHats,
                productPresenters.gildanZipUpSweatshirt,
                productPresenters.cottoVerWomensTShirt,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.selfInkingStamps,
                productPresenters.giftCertificates,
                productPresenters.loyaltyCardStamp,
                productPresenters.letterhead,
                productPresenters.circleStamps,
                productPresenters.notebooks,
                productPresenters.notepads,
                productPresenters.greenLineStamps,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.saveTheDateCards,
                productPresenters.weddingFoamBoards,
                productPresenters.weddingMenuCards,
                productPresenters.weddingPrograms,
                productPresenters.rsvpCards,
                productPresenters.saveTheDateMagnet,
                productPresenters.enclosureCards,
            ],
        },
    ],
    'it-CH': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.squareBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.plasticBusinessCards,
                productPresenters.qrCodeBusinessCards,
                productPresenters.glossyBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.wrappingPaper,
                productPresenters.paperBag,
                productPresenters.raisedFoilSwingTags,
                productPresenters.mailerBoxes,
                productPresenters.hangTags,
                productPresenters.pillowBoxesEu,
                productPresenters.customPizzaBoxes,
                productPresenters.papercup,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.menus,
                productPresenters.postcards,
                productPresenters.foldedLeaflets,
                productPresenters.placemats,
                productPresenters.magneticPostcards,
                productPresenters.presentationFolders,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.posters,
                productPresenters.carDoorMagnets,
                productPresenters.windowDecals,
                productPresenters.euVinylBanners,
                productPresenters.retractableBanners,
                productPresenters.lawnSigns,
                productPresenters.windowClings,
                productPresenters.metalSigns,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.giftCertificates,
                productPresenters.selfInkingStamps,
                productPresenters.loyaltyCardStamp,
                productPresenters.notebooks,
                productPresenters.letterhead,
                productPresenters.invoicePads,
                productPresenters.pocketStamps,
                productPresenters.greenLineStamps,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.productLabels,
                productPresenters.rollLabels,
                productPresenters.customStickers,
                productPresenters.returnAddressLabels,
                productPresenters.kidsLabels,
                productPresenters.ovalStickers,
                productPresenters.wineLabels,
                productPresenters.euRectangleStickers,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.cottoVerMensTShirt,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.footballShirt,
                productPresenters.consumerDrawstringBag,
                productPresenters.multiDecoVistaprintEmbroideredHats,
                productPresenters.embroideredPolos,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.kidsFootballShirts,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingMenuCards,
                productPresenters.weddingFoamBoards,
                productPresenters.saveTheDateCards,
                productPresenters.saveTheDateMagnet,
            ],
        },
    ],
    'it-IT': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.squareBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.softTouchBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.hangTags,
                productPresenters.wrappingPaper,
                productPresenters.raisedFoilSwingTags,
                productPresenters.mailerBoxes,
                productPresenters.papercup,
                productPresenters.promotionalBoxesEu,
                productPresenters.paperBag,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.foldedLeaflets,
                productPresenters.postcards,
                productPresenters.bookmarks,
                productPresenters.presentationFolders,
                productPresenters.menus,
                productPresenters.singlePocketFolders,
                productPresenters.presentationFolders,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.retractableBanners,
                productPresenters.windowDecals,
                productPresenters.euVinylBanners,
                productPresenters.posters,
                productPresenters.carDoorMagnets,
                productPresenters.metalSigns,
                productPresenters.lawnSigns,
                productPresenters.pvcFoamBoard,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.giftCertificates,
                productPresenters.selfInkingStamps,
                productPresenters.letterhead,
                productPresenters.notepads,
                productPresenters.circleStamps,
                productPresenters.loyaltyCardStamp,
                productPresenters.notebooks,
                productPresenters.textileStamps,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.rollLabels,
                productPresenters.returnAddressLabels,
                productPresenters.productLabels,
                productPresenters.circleStickers,
                productPresenters.euRectangleStickers,
                productPresenters.envelopeSeals,
                productPresenters.foodLabels,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.standardEmbroideredHats,
                productPresenters.cottoVerMensTShirt,
                productPresenters.embroideredPolos,
                productPresenters.cottoVerWomensTShirt,
                productPresenters.gildanZipUpSweatshirt,
                productPresenters.premiumZipToteBags,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingMenuCards,
                productPresenters.weddingFoamBoards,
                productPresenters.saveTheDateCards,
                productPresenters.weddingPrograms,
                productPresenters.enclosureCards,
                productPresenters.saveTheDateMagnet,
                productPresenters.rsvpCards,
            ],
        },
    ],
    'nb-NO': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.qrCodeBusinessCards,
                productPresenters.glossyBusinessCards,
                productPresenters.loyaltyCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.wrappingPaper,
                productPresenters.hangTags,
                productPresenters.paperBag,
                productPresenters.papercup,
                productPresenters.mailerBoxes,
                productPresenters.flexiblePackagingDoypacks,
                productPresenters.promotionalBoxesEu,
                productPresenters.fliplidboxes,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.foldedLeaflets,
                productPresenters.postcards,
                productPresenters.menus,
                productPresenters.bookmarks,
                productPresenters.doorHanger,
                productPresenters.presentationFolders,
                productPresenters.tableTents,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.posters,
                productPresenters.retractableBanners,
                productPresenters.outdoorPoster,
                productPresenters.windowDecals,
                productPresenters.euVinylBanners,
                productPresenters.carDoorMagnets,
                productPresenters.pvcFoamBoard,
                productPresenters.metalSigns,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.giftCertificates,
                productPresenters.selfInkingStamps,
                productPresenters.notebooks,
                productPresenters.loyaltyCardStamp,
                productPresenters.handStamps,
                productPresenters.greenLineStamps,
                productPresenters.notepads,
                productPresenters.letterhead,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.productLabels,
                productPresenters.rollLabels,
                productPresenters.foodLabels,
                productPresenters.returnAddressLabels,
                productPresenters.wineLabels,
                productPresenters.stickerSingles,
                productPresenters.circleStickers,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.cottoVerMensTShirt,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.embroideredPolos,
                productPresenters.multiDecoVistaprintEmbroideredHats,
                productPresenters.gildanZipUpSweatshirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingFoamBoards,
                productPresenters.weddingPrograms,
                productPresenters.weddingMenuCards,
                productPresenters.saveTheDateCards,
                productPresenters.saveTheDateMagnet,
                productPresenters.rsvpCards,
            ],
        },
    ],
    'nl-BE': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.glossyBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.softTouchBusinessCards,
                productPresenters.matteBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.hangTags,
                productPresenters.wrappingPaper,
                productPresenters.mailerBoxes,
                productPresenters.promotionalBoxesEu,
                productPresenters.pillowBoxesEu,
                productPresenters.papercup,
                productPresenters.paperBag,
                productPresenters.fliplidboxes,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.postcards,
                productPresenters.foldedLeaflets,
                productPresenters.menus,
                productPresenters.bookmarks,
                productPresenters.presentationFolders,
                productPresenters.customTickets,
                productPresenters.doorHanger,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.carDoorMagnets,
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.windowDecals,
                productPresenters.posters,
                productPresenters.carWindowDecals,
                productPresenters.metalSigns,
                productPresenters.flags,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.giftCertificates,
                productPresenters.selfInkingStamps,
                productPresenters.circleStamps,
                productPresenters.notepads,
                productPresenters.letterhead,
                productPresenters.notebooks,
                productPresenters.loyaltyCardStamp,
                productPresenters.invoicePads,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.returnAddressLabels,
                productPresenters.rollLabels,
                productPresenters.productLabels,
                productPresenters.envelopeSeals,
                productPresenters.circleStickers,
                productPresenters.stickerSingles,
                productPresenters.nameTags,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.standardEmbroideredHats,
                productPresenters.embroideredPolos,
                productPresenters.cottoVerMensTShirt,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.fruitOfTheLoomPremiumHoodedSweatJacket,
                productPresenters.fruitOfTheLoomValueweightLongsleeveT,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.saveTheDateCards,
                productPresenters.weddingMenuCards,
                productPresenters.weddingFoamBoards,
                productPresenters.enclosureCards,
                productPresenters.weddingPrograms,
                productPresenters.saveTheDateMagnet,
                productPresenters.rsvpCards,
            ],
        },
    ],
    'nl-NL': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.glossyBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.qrCodeBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.hangTags,
                productPresenters.wrappingPaper,
                productPresenters.promotionalBoxesEu,
                productPresenters.mailerBoxes,
                productPresenters.flexiblePackagingDoypacks,
                productPresenters.raisedFoilSwingTags,
                productPresenters.flatPouches,
                productPresenters.fliplidboxes,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.postcards,
                productPresenters.foldedLeaflets,
                productPresenters.menus,
                productPresenters.presentationFolders,
                productPresenters.bookmarks,
                productPresenters.customTickets,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.carDoorMagnets,
                productPresenters.retractableBanners,
                productPresenters.posters,
                productPresenters.euVinylBanners,
                productPresenters.windowDecals,
                productPresenters.metalSigns,
                productPresenters.carDoorDecals,
                productPresenters.foamBoards,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.giftCertificates,
                productPresenters.selfInkingStamps,
                productPresenters.letterhead,
                productPresenters.circleStamps,
                productPresenters.notepads,
                productPresenters.notebooks,
                productPresenters.loyaltyCardStamp,
                productPresenters.invoicePads,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.returnAddressLabels,
                productPresenters.rollLabels,
                productPresenters.productLabels,
                productPresenters.euRectangleStickers,
                productPresenters.stickerSingles,
                productPresenters.envelopeSeals,
                productPresenters.circleStickers,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.embroideredPolos,
                productPresenters.cottoVerMensTShirt,
                productPresenters.fullCustomSportsBomberJacket,
                productPresenters.standardEmbroideredHats,
                productPresenters.multiDecoVistaprintEmbroideredHats,
                productPresenters.vistaPrintPrintedBaseballCap,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingMenuCards,
                productPresenters.saveTheDateCards,
                productPresenters.weddingFoamBoards,
                productPresenters.enclosureCards,
                productPresenters.saveTheDateMagnet,
                productPresenters.weddingPrograms,
                productPresenters.rsvpCards,
            ],
        },
    ],
    'pt-PT': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.matteBusinessCards,
                productPresenters.plasticBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.metallicBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.promotionalBoxesEu,
                productPresenters.fliplidboxes,
                productPresenters.pulloutBoxes,
                productPresenters.wrappingPaper,
                productPresenters.mailerBoxes,
                productPresenters.flexiblePackagingDoypacks,
                productPresenters.hangTags,
                productPresenters.autoLockBoxes,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.foldedLeaflets,
                productPresenters.menus,
                productPresenters.postcards,
                productPresenters.presentationFolders,
                productPresenters.bookmarks,
                productPresenters.ringBinders,
                productPresenters.spotUvPostcards,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.euVinylBanners,
                productPresenters.posters,
                productPresenters.retractableBanners,
                productPresenters.metalSigns,
                productPresenters.carDoorMagnets,
                productPresenters.bumperStickers,
                productPresenters.windowDecals,
                productPresenters.euFabricBanners,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.giftCertificates,
                productPresenters.notebooks,
                productPresenters.letterhead,
                productPresenters.selfInkingStamps,
                productPresenters.circleStamps,
                productPresenters.notepads,
                productPresenters.textileStamps,
                productPresenters.journals,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.rollLabels,
                productPresenters.customStickers,
                productPresenters.wineLabels,
                productPresenters.returnAddressLabels,
                productPresenters.circleStickers,
                productPresenters.stickerSingles,
                productPresenters.productLabels,
                productPresenters.cosmeticLabels,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.standardEmbroideredHats,
                productPresenters.embroideredPolos,
                productPresenters.fullCustomCyclingJersey,
                productPresenters.footballShirt,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.basicMensLongSleeveTShirt,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingMenuCards,
                productPresenters.weddingFoamBoards,
                productPresenters.saveTheDateCards,
                productPresenters.weddingPrograms,
                productPresenters.rsvpCards,
                productPresenters.enclosureCards,
                productPresenters.saveTheDateMagnet,
            ],
        },
    ],
    'sv-SE': [
        {
            ...categories.logoAndBrand,
            products: [
                productPresenters.logoEssential,
                productPresenters.standardBusinessCards,
                productPresenters.flyersandLeaflets,
                productPresenters.letterhead,
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.businessCards,
            products: [
                productPresenters.standardBusinessCards,
                productPresenters.matteBusinessCards,
                productPresenters.roundedCornerBusinessCards,
                productPresenters.raisedFoilBusinessCards,
                productPresenters.loyaltyCards,
                productPresenters.spotUVBusinessCards,
                productPresenters.squareBusinessCards,
                productPresenters.glossyBusinessCards,
            ],
        },
        {
            ...categories.packaging,
            products: [
                productPresenters.paperBag,
                productPresenters.wrappingPaper,
                productPresenters.hangTags,
                productPresenters.mailerBoxes,
                productPresenters.papercup,
                productPresenters.iceCreamCup,
                productPresenters.shippingBoxes,
                productPresenters.fliplidboxes,
            ],
        },
        {
            ...categories.marketingMaterials,
            products: [
                productPresenters.flyersandLeaflets,
                productPresenters.postcards,
                productPresenters.foldedLeaflets,
                productPresenters.menus,
                productPresenters.bookmarks,
                productPresenters.doorHanger,
                productPresenters.ringBinders,
                productPresenters.photoboothMagnets,
            ],
        },
        {
            ...categories.signsAndPosters,
            products: [
                productPresenters.posters,
                productPresenters.retractableBanners,
                productPresenters.windowDecals,
                productPresenters.carDoorMagnets,
                productPresenters.metalSigns,
                productPresenters.euVinylBanners,
                productPresenters.foamBoards,
                productPresenters.lawnSigns,
            ],
        },
        {
            ...categories.stationery,
            products: [
                productPresenters.selfInkingStamps,
                productPresenters.giftCertificates,
                productPresenters.circleStamps,
                productPresenters.notebooks,
                productPresenters.letterhead,
                productPresenters.loyaltyCardStamp,
                productPresenters.notepads,
                productPresenters.textileStamps,
            ],
        },
        {
            ...categories.banners,
            products: [
                productPresenters.retractableBanners,
                productPresenters.euVinylBanners,
                productPresenters.euMeshBanners,
                productPresenters.outdoorPoster,
            ],
        },
        {
            ...categories.labelsAndStickers,
            products: [
                productPresenters.customStickers,
                productPresenters.rollLabels,
                productPresenters.productLabels,
                productPresenters.returnAddressLabels,
                productPresenters.envelopeSeals,
                productPresenters.circleStickers,
                productPresenters.stickerSingles,
                productPresenters.euRectangleStickers,
            ],
        },
        {
            ...categories.clothingAndBags,
            products: [
                productPresenters.fruitOfTheLoomBasicTShirt,
                productPresenters.cottoVerMensTShirt,
                productPresenters.standardEmbroideredHats,
                productPresenters.embroideredPolos,
                productPresenters.vistaPrintPrintedBaseballCap,
                productPresenters.classicCottonToteBagSmall,
            ],
        },
        {
            ...categories.wedding,
            products: [
                productPresenters.weddingInvitations,
                productPresenters.weddingPrograms,
                productPresenters.saveTheDateCards,
                productPresenters.weddingFoamBoards,
                productPresenters.weddingMenuCards,
                productPresenters.saveTheDateMagnet,
                productPresenters.rsvpCards,
                productPresenters.enclosureCards,
            ],
        },
    ],
});
